import bankGlobal66 from '../../banksPNG/bankGlobal66.png';

interface IconProps {
	width?: string;
	height?: string;
	alt?: string;
}
export const BancoGlobal66Icon = ({
	width = '17px',
	height = '17px',
	alt = 'Banco GLobal 66',
}: IconProps) => <img src={bankGlobal66} width={width} height={height} alt={alt} />;
